/* ─── RETRO SPEED SHOP · THEME JS ─── */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Countdown Timer ── */
  const countdown = document.querySelector('.countdown[data-end]');
  if (countdown) {
    const end = new Date(countdown.dataset.end).getTime();
    function tick() {
      const diff = end - Date.now();
      if (diff <= 0) return;
      const h = String(Math.floor(diff / 3600000)).padStart(2, '0');
      const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      const hEl = document.getElementById('drop-hours');
      const mEl = document.getElementById('drop-mins');
      const sEl = document.getElementById('drop-secs');
      if (hEl) hEl.textContent = h;
      if (mEl) mEl.textContent = m;
      if (sEl) sEl.textContent = s;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── Wishlist Toggle ── */
  document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const active = btn.classList.toggle('active');
      btn.textContent = active ? '♥' : '♡';
    });
  });

  /* ── Quick Add to Cart (AJAX) ── */
  document.querySelectorAll('.quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = btn.dataset.productId;
      if (!variantId) return;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          btn.style.background = '#27ae60';
          updateCartCount();
          setTimeout(function () {
            btn.textContent = 'Quick Add';
            btn.style.background = '';
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = 'Error';
          btn.disabled = false;
        });
    });
  });

  /* ── Update Cart Count in Nav ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.cart-count');
        if (badge) badge.textContent = cart.item_count;
      });
  }

  /* ── Product Page: Variant Selector ── */
  document.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.variant-group');
      group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant() {
    var select = document.getElementById('variant-select');
    if (!select) return;
    var activeBtns = document.querySelectorAll('.variant-btn.active');
    var values = Array.from(activeBtns).map(function (b) { return b.dataset.value; });
    var options = select.querySelectorAll('option');
    options.forEach(function (opt) {
      var title = opt.textContent.split(' - ')[0].trim();
      if (values.some(function (v) { return title.includes(v); })) {
        opt.selected = true;
      }
    });
  }

  /* ── Add to Cart Form ── */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
  if (e.submitter && e.submitter.name !== 'add') return;
  e.preventDefault();
      var submitBtn = productForm.querySelector('[name="add"]');
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;
      var formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: formData.get('id'),
          quantity: parseInt(formData.get('quantity')) || 1
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          submitBtn.textContent = 'Added to Cart ✓';
          submitBtn.style.background = '#27ae60';
          updateCartCount();
          setTimeout(function () {
            submitBtn.textContent = 'Add to Cart';
            submitBtn.style.background = '';
            submitBtn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          submitBtn.textContent = 'Add to Cart';
          submitBtn.disabled = false;
        });
    });
  }

  /* ── Mobile Nav Toggle ── */
  var menuToggle = document.getElementById('mobile-menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

});
